class VersionChecker {
  constructor() {
    this.currentVersion = null
    this.serverVersion = null
    this.listeners = []
    this.checkInterval = null
    this.dismissCount = 0
    this.maxDismiss = 3
    this.isChecking = false
    this.updateDetected = false
    this.checksCount = 0
  }

  async init() {
    try {
      const res = await fetch('/version.json?_=' + Date.now(), {
        method: 'GET',
        cache: 'no-store',
        headers: {
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          Pragma: 'no-cache',
          Expires: '0'
        }
      })

      if (!res.ok) throw new Error('Error al cargar version.json')

      const data = await res.json()
      this.currentVersion = data.version
      this.serverVersion = data.version

      localStorage.setItem('app_version', data.version)
      localStorage.setItem('version_checker_v2', 'true')

      this.dismissCount = parseInt(localStorage.getItem('update_dismiss_count') || '0')

      return this.currentVersion
    } catch (e) {
      this.currentVersion = '1.0.0'
      return this.currentVersion
    }
  }

  async check() {
    if (this.isChecking) return null

    const shouldNotify = !(this.updateDetected && this.dismissCount >= this.maxDismiss)

    this.isChecking = true
    this.checksCount++

    try {
      const res = await fetch('/version.json?_=' + Date.now(), {
        method: 'GET',
        cache: 'no-store',
        headers: {
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          Pragma: 'no-cache',
          Expires: '0'
        }
      })

      if (!res.ok) {
        this.isChecking = false
        return null
      }

      const data = await res.json()
      this.serverVersion = data.version

      if (data.version !== this.currentVersion) {
        if (!this.updateDetected) {
          this.updateDetected = true
          this.dismissCount = 0
          localStorage.setItem('update_dismiss_count', '0')
        }

        if (shouldNotify) {
          this.listeners.forEach((cb) => cb(data.version))
        }

        this.isChecking = false
        return data.version
      }
    } catch (e) {
      // Error silencioso
    }

    this.isChecking = false
    return null
  }

  onUpdate(callback) {
    this.listeners.push(callback)
  }

  start() {
    setTimeout(() => this.check(), 10000)
    this.checkInterval = setInterval(() => this.check(), 120000)
  }

  stop() {
    if (this.checkInterval) {
      clearInterval(this.checkInterval)
      this.checkInterval = null
    }
  }

  notifyLater() {
    this.dismissCount++
    localStorage.setItem('update_dismiss_count', this.dismissCount.toString())
    return this.dismissCount < this.maxDismiss
  }

  getDismissCount() {
    return this.dismissCount
  }

  async reload() {
    this.stop()

    const token = localStorage.getItem('token')
    const sessionToken = localStorage.getItem('session_token')

    if (token && sessionToken) {
      try {
        const response = await fetch(process.env.VUE_APP_ROOT_API + '/user', {
          headers: {
            Authorization: 'Bearer ' + token,
            'X-Session-Token': sessionToken
          }
        })

        if (!response.ok) {
          window.location.href = '/#/login?reason=session_expired'
          return
        }
      } catch (e) {
        window.location.href = '/#/login?reason=session_expired'
        return
      }
    }

    localStorage.removeItem('update_dismiss_count')

    if ('caches' in window) {
      caches.keys().then((names) => {
        names.forEach((name) => caches.delete(name))
      })
    }

    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then((regs) => {
        regs.forEach((reg) => reg.unregister())
      })
    }

    setTimeout(() => window.location.reload(true), 100)
  }
}

const instance = new VersionChecker()
export default instance
